<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :on-cancel="onCancel"
      :is-full-page="fullPage"
    ></loading>

    <h1>Lagerbestand</h1>

    <div class="card">
      <div class="card-body">
        <BaseFilteringComponent :showNoDateFilter="1"></BaseFilteringComponent>

        <div class="form-group row">
          <div class="col-sm-1 col-form-label">SKU Suche</div>
          <div class="col-md-2">
            <input
              type="text"
              v-model="filter_sku"
              class="form-control form-control-sm"
              placeholder="SKU"
            />
          </div>

          <div class="col-sm-1 col-form-label">EAN Suche</div>
          <div class="col-md-2">
            <input
              type="text"
              v-model="filter_ean"
              class="form-control form-control-sm"
              placeholder="SKU"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="float-right">
              <button v-on:click="refreshData" class="btn btn-primary btn-sm">
                <font-awesome-icon icon="sync" />Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a
      @click="downloadCSV"
      class="btn btn-primary btn-sm"
      style="margin-top: 10px; margin-bottom: 10px"
    >
      <font-awesome-icon icon="download" />CSV Download
    </a>

    <table class="table table-bordered table-striped table-small">
      <thead>
        <tr>
          <th>SKU</th>
          <th>Produkt</th>
          <th>EAN</th>
          <th>Lagerbestand</th>
          <th>Reserv. Lagerbestand</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="stock_item in stockListing" :key="stock_item.id">
          <td>{{stock_item.sku}}</td>
          <td>{{stock_item.name}}</td>
          <td>{{stock_item.ean}}</td>
          <td>
            <div class="float-right">{{stock_item.in_stock}}</div>
          </td>
          <td>
            <div class="float-right">{{stock_item.reserved_stock}}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
const request = require("superagent");
import axios from "axios";
import Loading from "vue-loading-overlay";
import FileSaver from "file-saver";
import BaseFilteringComponent from "@/components/BaseFilteringComponent";

export default {
  name: "Stocks",
  components: {
    Loading,
    BaseFilteringComponent: BaseFilteringComponent,
  },
  data() {
    return {
      stockListing: [],
      isLoading: false,
      fullPage: true,
      api_token: "",
      shopFilter: null,
      filter_ean: "",
      filter_sku: "",
    };
  },
  computed: {
    shopListing: function () {
      return this.$store.state.shops;
    },
    filterShopId() {
      return this.$store.state.filter_shop_id;
    },
    currentUser: function () {
      return this.$store.state.current_user;
    },
    downloadUrl: function () {
      var url = this.baseUrl + "&format=csv";
      if (this.baseUrl.includes("?")) {
        url = this.baseUrl + "&format=csv";
      } else {
        url = this.baseUrl + "?format=csv";
      }

      return url;
    },
    baseUrl() {
      var url = process.env.API_HOST + "/api/stocks/instock";
      url = url + "?filter_ean=" + this.filter_ean;
      url = url + "&filter_sku=" + this.filter_sku;

      if (
        this.currentUser.master == 1 &&
        this.filterShopId != null &&
        parseInt(this.filterShopId) != 0
      ) {
        url = url + "&filter_shop_ids=" + this.filterShopId;
      }
      return url;
    },
  },
  mounted: function () {
    this.api_token = localStorage.getItem("API_TOKEN");
  },
  methods: {
    downloadCSV() {
      var that = this;
      request
        .get(this.downloadUrl)
        .set("Authorization", this.api_token)
        .then(function (res) {
          var blob = new Blob(["\uFEFF" + res.text], {
            type: "text/comma-separated-values;charset=utf-8",
          });

          FileSaver.saveAs(blob, "lagerbestand.csv", { autoBom: true });
        });
    },
    refreshData: function () {
      this.fetchData();
    },
    fetchData: function () {
      var url = this.baseUrl;

      this.isLoading = true;
      var that = this;
      request
        .get(url)
        .set("Accept", "application/json")
        .set("Authorization", this.api_token)
        .then(function (res) {
          that.stockListing = res.body.data;
          that.isLoading = false;
        });
    },
    onCancel() {},
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Stocks.vue